import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {map, Observable, take} from 'rxjs';
import {GeneralNotificationsService} from '../../services/general-notifications/general-notifications.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentNoticeGuard implements CanActivate {
  private generalNotificationsService = inject(GeneralNotificationsService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    // Permettiamo sempre l'accesso alla pagina del canone e alla home
    if (state.url === '/studio/licenza/canone' || state.url === '/home') {
      return true;
    }

    return this.generalNotificationsService.notifications$.pipe(
      take(1),
      map(notes => {
        const hasPhase4 = notes.some(n => n.categoria === 'canone' && n.fase >= 4);
        return !hasPhase4;
      })
    );
  }
}
